import {CommonModule, registerLocaleData} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LOCALE_ID, NgModule} from '@angular/core';
import { QuillModule } from 'ngx-quill';
import { RouterModule } from '@angular/router';

import { AccueilComponent } from './accueil/accueil.component';
import { AddBlockButtonComponent } from './pages/page-blocks/add-block-button/add-block-button.component';
import { CommentsComponent } from './comments/comments.component';
import { DocumentEditComponent } from './documents/document-edit/document-edit.component';
import { DocumentFormComponent } from './documents/document-form/document-form.component';
import { DocumentNewComponent } from './documents/document-new/document-new.component';
import { DocumentsComponent } from './documents/documents.component';
import { EditTextComponent } from './pages/page-blocks/edit-text/edit-text.component';
import { FilePickerComponent } from './common/file-picker/file-picker.component';
import { IconComponent } from './common/icon-picker/icon-picker.component';
import { ImageEditComponent } from './images/image-edit/image-edit.component';
import { ImageFormComponent } from './images/image-form/image-form.component';
import { ImageNewComponent } from './images/image-new/image-new.component';
import { ImagesComponent } from './images/images.component';
import { MatAngularModule } from '@Common/mat-angular.module';
import { PageBlockComponent } from './common/page-block/page-block.component';
import { PageBlocksComponent } from './pages/page-blocks/page-blocks.component';
import { PageEditComponent } from './pages/page-edit/page-edit.component';
import { PageFormComponent } from './pages/page-form/page-form.component';
import { PageNewComponent } from './pages/page-new/page-new.component';
import { PagesComponent } from './pages/pages.component';
import { ROUTES } from './settings.routes';
import { SettingsComponent } from './settings.component';
import { SettingsFooterComponent } from './common/settings-footer/settings-footer.component';
import { SettingsHeaderComponent } from './common/settings-header/settings-header.component';
import { SettingsPageComponent } from './common/settings-page/settings-page.component';

import {CommonModuleP8} from '@Common/common-p8.module';

import { MatPaginatorIntl } from '@angular/material/paginator';

import { ImagePreviewComponent } from './images/image-preview/image-preview.component';
import { EditImageComponent } from './pages/page-blocks/edit-image/edit-image.component';
import { SelectMediaModalComponent } from './pages/page-blocks/edit-image/select-media-modal/select-media-modal.component';
import { SelectDocModalComponent } from './pages/page-blocks/select-doc-modal/select-doc-modal.component';
import {SearchPagesComponent} from '../common/components/search-admin-pages.component';

import { PageListModalComponent } from './pages/page-list-modal/page-list-modal.component';

import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { DocumentAddModaleComponent } from './documents/document-add-modale/document-add-modale.component';
import { ImageAddModaleComponent } from './images/image-add-modale/image-add-modale.component';
import { CommentModaleComponent } from './comments/comment-modale/comment-modale.component';
import { SettingsGestionnairesComponent } from './common/settings-gestionnaires/settings-gestionnaires.component';
import {AwDndComponent} from '../page/aw-dnd/aw-dnd.component';
import { FeedbacksComponent } from './feedbacks/feedbacks.component';
import { FeedbackModaleComponent } from './feedbacks/feedback-modale/feedback-modale.component';
// import {TreeComponent} from '../page/tree/tree.component';
import {CustomPaginatorService} from './common/custom-paginator/custom-paginator.service';
import {CommonBdcModule} from '../common/common-bdc.module';

registerLocaleData(localeFr, 'fr-FR', localeFrExtra);

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatAngularModule,
        QuillModule.forRoot(),
        ReactiveFormsModule,
        RouterModule.forRoot(ROUTES, {}),
        CommonModuleP8,
        CommonBdcModule
    ],
    declarations: [
        AccueilComponent,
        AddBlockButtonComponent,
        CommentsComponent,
        DocumentEditComponent,
        DocumentFormComponent,
        DocumentNewComponent,
        DocumentsComponent,
        EditTextComponent,
        FilePickerComponent,
        IconComponent,
        ImageEditComponent,
        ImageFormComponent,
        ImageNewComponent,
        ImagesComponent,
        PageBlockComponent,
        PageBlocksComponent,
        PageEditComponent,
        PageFormComponent,
        PageNewComponent,
        PagesComponent,
        SettingsComponent,
        SettingsFooterComponent,
        SettingsHeaderComponent,
        SettingsPageComponent,
        ImagePreviewComponent,
        EditImageComponent,
        SelectMediaModalComponent,
        SelectDocModalComponent,
        SearchPagesComponent,
        PageListModalComponent,
        DocumentAddModaleComponent,
        ImageAddModaleComponent,
        CommentModaleComponent,
        SettingsGestionnairesComponent,
        AwDndComponent,
        FeedbacksComponent,
        FeedbackModaleComponent,
        // TreeComponent
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: CustomPaginatorService },
        { provide: LOCALE_ID, useValue: 'fr-FR' },
    ]
})
export class SettingsModule { }
